<template>
  <section class="worldAreaWeather">
    <div class="header">
      <div class="inner">
        <SectionTitle :title="`世界各地の${isRadar ? '雨雲レーダー' : '天気'}`" />
      </div>
      <div class="search">
        <div class="search__content">
          <button class="search__button" />
          <input
            v-model="keyword"
            type="search"
            placeholder="国名・都市名で検索"
          >
          <button class="search__button" />
        </div>
        <SearchPointCandidate
          v-show="keyword !== ''"
          :result="result"
          :is-radar="isRadar"
        />
      </div>
    </div>
    <CommonAccordionCountryList
      :is-radar="isRadar"
      :is-country="isCountry"
    />
  </section>
</template>

<script setup>
import searchPointList from '~/data/table/search_point_list.json'

defineProps({
  isRadar: {
    type: Boolean,
    required: false,
    default: false
  },
  isCountry: {
    type: Boolean,
    required: false,
    default: false
  }
})

const { keyword, result } = useWorldPointSearch({ searchPointList })
</script>

<style lang="scss" scoped>
.worldAreaWeather {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .header {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

    }

    .search {
      position: relative;
      &__content {
        position: relative;
        border-radius: 100vmax;
        border: 1px solid #3569C0;
        background-color: #FFF;
        overflow: hidden;
        z-index: 2;
      }
      &__button {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 100%;
        background-color: #3569C0;
        background-image: url('~/assets/images/common/icon_search_white.svg');
        background-position: left 8px center;
        background-size: 20px;
        background-repeat: no-repeat;
        border-left: solid 1px #3569C0;
      }
      input {
        display: block;
        width: 100%;
        padding: 3px 40px 3px 10px;
        color: #303030;
        font-size: 16px;
        font-weight: 600;
        line-height: 33px;
        outline: none;
        touch-action: manipulation;
      }
    }
  }
}

.main {
  .worldAreaWeather {
    @media screen and (min-width: 830px) {
      .header {
        flex-direction: row;
        justify-content: space-between;
      }
      .search {
        width: 50%;
      }
    }
  }
}
</style>
